<template>
    <div class="login-wrapper">
        <div class="login-header" :class="($route.name === 'parkPay' ? 'login-header--pay' : '')">
            <div class="logo-wrapper">
                <a href="/">

                </a>
            </div>
        </div>
        <div class="login-page">
            <div class="login-box">
                <router-view></router-view>
                <div class="footer-text">
                    © PARKTIME.PRO LLC {{year}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            year: function () {
                let date = new Date()
                return date.getFullYear()
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">

</style>
